module.exports = __webpack_public_path__ + "img/empty-cart.7ab52b9.gif";